"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAndSliderSyncTool = void 0;
const react_1 = require("react");
const interface_1 = require("./../../../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.TextAndSliderSyncTool = {
    /**需要注意的是在平仓的情况下，返回的volume的值实际上是平仓总量，而不是真正的价值 */
    useSeparateTradingSync: (actionType, perAmount, investPercent, count, _sumPrice, available, symbol, reduceOnly, investSide, leverage) => {
        const lastPerAmount = (0, react_1.useRef)("");
        const lastPercent = (0, react_1.useRef)(undefined);
        // 仅减仓的时候，价格总数应该等于格子数,为 quote 时
        const sumPrice = (() => {
            if (reduceOnly) {
                return count;
            }
            if (investSide === interface_1.InvestSymbolSide.base) {
                return _sumPrice;
            }
            return count;
        })();
        (0, react_1.useMemo)(() => {
            if (actionType === "text") {
                lastPerAmount.current = "";
                lastPercent.current = 0;
                lastPerAmount.current = perAmount;
                // input text
                const invalid = !Number(available) || Number(count) < 2 || !Number(sumPrice);
                if (!invalid) {
                    const volume = new trade_utils_lib_1.SafeDecimal(perAmount).mul(new trade_utils_lib_1.SafeDecimal(sumPrice));
                    let percent = 0;
                    percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toDP(2).toNumber();
                    lastPercent.current = percent > 1 ? 1 : percent;
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [actionType, perAmount]);
        (0, react_1.useMemo)(() => {
            if (actionType === "slider" && lastPercent.current !== investPercent) {
                lastPerAmount.current = "";
                lastPercent.current = 0;
                let volumePrecision;
                if (investSide === interface_1.InvestSymbolSide.base) {
                    volumePrecision = symbol.amount || 0;
                }
                else {
                    volumePrecision = symbol.precisionCost || 0;
                }
                // input by slider
                lastPercent.current = investPercent;
                const invalid = !Number(available) || Number(count) < 2 || !Number(sumPrice);
                if (!invalid) {
                    lastPercent.current = investPercent;
                    let amount = "";
                    amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).div(new trade_utils_lib_1.SafeDecimal(sumPrice)).toString();
                    if (investSide === interface_1.InvestSymbolSide.cost) {
                        amount = new trade_utils_lib_1.SafeDecimal(amount).div(leverage).toString();
                    }
                    lastPerAmount.current = new trade_utils_lib_1.SafeDecimal(amount).eq(0)
                        ? ""
                        : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, volumePrecision);
                }
            }
            // 这里的依赖不需要添加investSide和leverage，因为在变更investSide和leverage时不需要变更用户输入的量
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [actionType, investPercent]);
        (0, react_1.useMemo)(() => {
            const invalid = !Number(available) || !Number(sumPrice);
            if (!invalid) {
                const volume = new trade_utils_lib_1.SafeDecimal(lastPerAmount.current).mul(new trade_utils_lib_1.SafeDecimal(sumPrice));
                let percent = 0;
                let availableD = new trade_utils_lib_1.SafeDecimal(available);
                if (investSide === interface_1.InvestSymbolSide.cost) {
                    availableD = availableD.div(leverage);
                }
                percent = volume.div(availableD).toDP(2).toNumber();
                lastPercent.current = percent > 1 ? 1 : percent;
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [count, sumPrice, available, investSide, leverage]);
        return [lastPerAmount.current, lastPercent.current];
    },
};
